/** service-ai sends `ACTIVE`, `active`, `DRAFT`, `PUBLISHED`...; the UI speaks lowercase only (D-24). */
export const normalizeAiStatus = (status: string): string => status.trim().toLowerCase();

/** The record with its `status` normalized; the one place an AI endpoint's casing is settled. */
export const withNormalizedStatus = <T extends { status: string }>(record: T): T => ({
  ...record,
  status: normalizeAiStatus(record.status),
});
